import React from "react";
import styled from "styled-components";
import { Grey_Link, Input_, Main_ } from "monica-alexandria";
import { concurrentWorkConfirmationEvent } from "../utils/concurrent_work_confirmation";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 5000;
  min-height: 100vh;
  background: ${props => props.theme.overlay};
`;
const Background = styled.div`position: fixed; inset: 0;`;
const Dialog = styled.div`
  position: fixed;
  top: 5rem;
  left: 50%;
  width: calc(100vw - 4rem);
  max-width: 50rem;
  transform: translateX(-50%);
  padding: var(--normalPads);
  border-radius: var(--smallRadius);
  background: ${props => props.theme.background};
  text-align: center;
`;
const Close = styled.div`display: flex; justify-content: flex-end; margin-bottom: 1rem;`;
const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2rem;
  padding: 1rem 0;
`;
const YesButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: .5rem;
  padding: .7rem 1rem;
  border: 1px solid transparent;
  border-radius: var(--smallRadius);
  background: transparent;
  color: var(--main);
  cursor: pointer;
  font: inherit;
  &:disabled { cursor: not-allowed; opacity: .45; }
`;

export const Concurrent_Work_Confirmation_Dialog = props => {
  const [value, setValue] = React.useState("");
  const submitted = React.useRef(false);
  const enabled = value.trim().toLowerCase() === "yes";
  const confirm = () => {
    if (!enabled || submitted.current) return;
    submitted.current = true;
    props.onYes(value);
  };

  return (
    <Overlay className="ConcurrentWorkConfirmation">
      <Background onClick={props.onClose} />
      <Dialog role="dialog" aria-modal="true" aria-label={props.message}>
        <Close><Grey_Link noPadding size="small" iconLeft="Xicon" onClick={props.onClose} /></Close>
        <h4>{props.message}</h4>
        <Input_
          id="concurrent-work-confirmation-input"
          value={value}
          placeholder={props.confirmationPrompt}
          onChange={event => setValue(event.target.value)}
          onKeyDown={event => { if (event.key === "Enter") event.preventDefault(); }}
        />
        <Actions>
          <YesButton type="button" disabled={!enabled} onClick={confirm}>
            <span aria-hidden="true">✓</span><span>{props.yes}</span>
          </YesButton>
          <Main_ onClick={props.onNo} iconLeft="Xicon" text={props.no} />
        </Actions>
      </Dialog>
    </Overlay>
  );
};

export const Concurrent_Work_Confirmation = props => {
  const [pending, setPending] = React.useState(null);
  const pendingRef = React.useRef(null);
  const requestIdRef = React.useRef(0);

  React.useEffect(() => {
    const receive = event => {
      if (event.detail.handled) return;
      event.detail.handled = true;
      if (pendingRef.current) {
        event.detail.resolve("");
        return;
      }
      pendingRef.current = event.detail;
      setPending({ ...event.detail, id: ++requestIdRef.current });
    };
    window.addEventListener(concurrentWorkConfirmationEvent, receive);
    return () => {
      window.removeEventListener(concurrentWorkConfirmationEvent, receive);
      pendingRef.current?.resolve("");
      pendingRef.current = null;
    };
  }, []);

  const finish = value => {
    const request = pendingRef.current;
    pendingRef.current = null;
    setPending(null);
    request?.resolve(value);
  };

  return pending ? (
    <Concurrent_Work_Confirmation_Dialog
      key={pending.id}
      {...props}
      onYes={finish}
      onNo={() => finish("")}
      onClose={() => finish("")}
    />
  ) : null;
};
